import React, { useMemo, memo } from 'react';
import classnames from 'classnames';

import { getNotesArray } from './getNotesArray';
import { modulo } from '../../../util/modulo';

const getSnapsArray = (beatCount, partsPerBeat, partSnap) => {
   const snaps = [];
   for (
      let part = partSnap;
      part <= beatCount * partsPerBeat;
      part += partSnap
   ) {
      snaps.push(part);
   }
   return snaps;
};

const PianoRollGrid = memo(
   ({
      lowNote,
      highNote,
      noteHeight,
      beatCount,
      partsPerBeat,
      partWidth,
      snap,
   }) => {
      const notes = useMemo(() => getNotesArray(lowNote, highNote), [
         lowNote,
         highNote,
      ]);

      const snaps = useMemo(
         () => getSnapsArray(beatCount, partsPerBeat, snap),
         [beatCount, partsPerBeat, snap]
      );

      const gridHeight = (highNote - lowNote + 1) * noteHeight;
      const gridWidth = beatCount * partsPerBeat * partWidth;

      return (
         <svg width={gridWidth} height={gridHeight} className="piano-roll-grid">
            {notes.map((note, i) => {
               const isSharp = note.match('#');
               const needsBorder = note.match(/(b|e)\d/);

               if (isSharp || needsBorder) {
                  return (
                     <g key={note}>
                        {isSharp && (
                           <rect
                              className="piano-roll-grid-row"
                              height={noteHeight}
                              width={gridWidth}
                              y={i * noteHeight}
                              data-note-name={note}
                           />
                        )}
                        {needsBorder && (
                           <line
                              className="piano-roll-grid-row-gap"
                              x1={0}
                              x2={gridWidth}
                              y1={i * noteHeight}
                              y2={i * noteHeight}
                           />
                        )}
                     </g>
                  );
               }
               return null;
            })}
            {snaps.map((part) => (
               <line
                  key={part}
                  className={classnames({
                     'piano-roll-grid-column': true,
                     'piano-roll-grid-column-beat':
                        modulo(part, partsPerBeat) === 0,
                     'piano-roll-grid-column-bar':
                        modulo(part, partsPerBeat * 4) === 0,
                  })}
                  x1={partWidth * part}
                  x2={partWidth * part}
                  y1={0}
                  y2={gridHeight}
               />
            ))}
         </svg>
      );
   }
);

export { PianoRollGrid };
